.expand-button {
    position: absolute;
    right: -18px;
    top: 280px;
    height: 28px;
    width: 28px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Optically aligned */
.expand-button > span {
    transform: translateX(-1px);
}

.expand-button--collapsed > span {
    transform: translateX(1px);
}
